import { render, staticRenderFns } from "./QRReaderView.vue?vue&type=template&id=6349aa17&scoped=true"
import script from "./QRReaderView.vue?vue&type=script&lang=js"
export * from "./QRReaderView.vue?vue&type=script&lang=js"
import style1 from "./QRReaderView.vue?vue&type=style&index=1&id=6349aa17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6349aa17",
  null
  
)

export default component.exports